import Modal from './modules/modal.js'; //quite
import objectFitImages from './modules/objectfit.js'; //quite
import mobileMenu from './modules/mobile-menu.js'; //quite

//import * as Swiper from './extern/swiper.js'; //quite
import * as Cookie from './modules/cookie.js'; //quite
import * as Fancybox from './extern/jquery.fancybox.js'; //quite

//Touch sniffer
if ('ontouchstart' in document.documentElement) {
	document.querySelector('html').classList.add('is-touch');
}

// Init functions on pageload
function init() {
	objectFitImages();
	mobileMenu();
	new Modal();
}

jQuery(document).ready(function ($) {
	init();

	let observer = new IntersectionObserver(
		(entries, observer) => {
			entries.forEach((entry) => {
				if (entry.intersectionRatio > 0) {
					entry.target.classList.add('animate-it');
				}
			});
		},
		{ rootMargin: '0px 0px -10% 0px' }
	);

	const animationTriggers = document.querySelectorAll(
		'[data-animation-trigger]'
	);

	[...animationTriggers].forEach((animationTrigger) => {
		observer.observe(animationTrigger);
	});


	// sidepop -----------

	$('.sidepop .sluiten').on("click", function(){
		$('.sidepop').addClass("hide");
		Cookies.set('sidepop.hide','true', { expires: 7 });
	});
	if (Cookies.get('sidepop.hide')) {$('.sidepop').addClass('keep-hidden');}

	// Assumes that you're using jQuery and Bootstrap
	// The `ajaxurl` variable, should be declared in
	// header.php like so:
	// ajaxurl = '<?php echo admin_url('admin-ajax.php'); ?>';

	var $modal = $('#modal');
	var $modal_target = $('[data-modal="target"]');
	$('.refs').on('click', 'div.card', function (e) {
		e.preventDefault();
		var id = $(this).data('id');
		$.ajax({
			url: xpl.ajaxurl,
			data: {
				action: 'fetch_modal_content',
				id: id
			},
			success: function (data) {
				$modal_target.html(data);
				$modal.modal('show');
			}
		});
	});


});
